import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-primary/20 bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-163" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-164" data-mp="2vp6c4b7o0i88">
        <div className="text-center" data-id="element-165" data-mp="39hcsnyeqcr87">
          <SectionHeading id="problem-title" data-id="element-166" data-mp="39gb4cs8pe88j">Does This Sound Familiar?</SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-167" data-mp="35fiv3yzu03c9">
            You're working with hydrogen and fuel cell systems but struggle with gaps in technical understanding. When
            clients ask about electrolysis efficiency, production pathways, fuel cell performance, or storage
            infrastructure, you can't confidently explain the technical reasons.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-primary/40 bg-surface p-6 shadow-glow sm:p-8" data-id="element-168" data-mp="1k4sjecw7s49e">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-foreground" data-id="element-169" data-mp="x49uv69gfdov">
            <AlertTriangleIcon className="h-5 w-5 text-primary-strong" aria-hidden="true" data-id="element-170" data-mp="123v3k8eff0es" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-171" data-mp="171mxt92jmym5">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-172" data-mp="1c198pbuwg2rs">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-primary shadow-[0_0_8px_rgb(var(--color-primary)/0.8)]" aria-hidden="true" data-id="element-173" data-mp="1g348gbx6m83g" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-174" data-mp="3hvsesu54hbng">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-175" data-mp="3hwtsz7hfqe9e">
            Stop wasting personal time. You're already experienced. What you need is the right tool.
          </p>
          <p className="mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-176" data-mp="k3a8pdyrhbiz">
            Build your entire <span className="text-accent" data-id="element-177" data-mp="xym3flcx31zw">hydrogen knowledge</span> today.
          </p>
        </div>
      </div>
    </section>;
}